"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var interfaces_1 = require("./interfaces");
var javascript_time_ago_1 = __importDefault(require("javascript-time-ago"));
var en_1 = __importDefault(require("javascript-time-ago/locale/en"));
try {
    javascript_time_ago_1["default"].addDefaultLocale(en_1["default"]);
}
catch (e) {
}
var timeAgo = new javascript_time_ago_1["default"]('en-US');
require('./assets/styles.css');
var defaultWebSocket = 'wss://ws.notificationapi.com';
var notificationReqCount = 50;
function position(popup, popupInner, button, popupPosition) {
    var position = popupPosition.toString();
    var maxHeight = document.documentElement.clientHeight + 'px';
    var top = 'auto';
    var bottom = 'auto';
    var left = 'auto';
    var right = 'auto';
    if (window.innerWidth < 768) {
        top = -button.getBoundingClientRect().top + 'px';
        bottom =
            -(document.documentElement.clientHeight -
                button.getBoundingClientRect().bottom) + 'px';
        left = -button.getBoundingClientRect().left + 'px';
        right =
            -(document.documentElement.clientWidth -
                button.getBoundingClientRect().right) + 'px';
    }
    else {
        if (position.startsWith('top')) {
            bottom = button.clientHeight + 10 + 'px';
            maxHeight = button.getBoundingClientRect().top - 20 + 'px';
        }
        if (position.startsWith('bottom')) {
            bottom = 'auto';
            top = button.clientHeight + 10 + 'px';
            maxHeight =
                window.innerHeight - button.getBoundingClientRect().bottom - 40 + 'px';
        }
        if (position.startsWith('left')) {
            left = 'auto';
            right = button.clientWidth + 10 + 'px';
        }
        if (position.startsWith('right')) {
            right = 'auto';
            left = button.clientWidth + 10 + 'px';
        }
        if (position.endsWith('Top')) {
            top = 'auto';
            bottom = '0px';
            maxHeight = button.getBoundingClientRect().bottom - 20 + 'px';
        }
        if (position.endsWith('Bottom')) {
            bottom = 'auto';
            top = '0px';
            maxHeight =
                window.innerHeight - button.getBoundingClientRect().top - 40 + 'px';
        }
        if (position.endsWith('Left')) {
            left = 'auto';
            right = '0px';
        }
        if (position.endsWith('Right')) {
            right = 'auto';
            left = '0px';
        }
    }
    popup.style.top = top;
    popup.style.bottom = bottom;
    popup.style.left = left;
    popup.style.right = right;
    popupInner.style.maxHeight = maxHeight;
}
var NotificationAPIClient = (function () {
    function NotificationAPIClient(options) {
        var _this = this;
        var _a;
        this.destroy = function () {
            var _a;
            (_a = _this.websocket) === null || _a === void 0 ? void 0 : _a.close();
            Object.values(_this.elements).map(function (e) {
                e && e.remove();
            });
        };
        this.showInApp = function (options) {
            _this.state.inappOptions = options;
            var root = document.getElementById(options.root);
            if (!root) {
                console.error("There are no HTML elements with id=\"".concat(options.root, "\" on the page."));
                return;
            }
            _this.elements.root = root;
            if (options.popupPosition &&
                !Object.values(interfaces_1.PopupPosition).includes(options.popupPosition)) {
                console.error("\"".concat(options.popupPosition, "\" is not a valid position. Valid positions: ").concat(Object.values(interfaces_1.PopupPosition).join(', ')));
                return;
            }
            if (root.hasChildNodes()) {
                root.innerHTML = '';
            }
            var container = document.createElement('div');
            container.classList.add('notificationapi-container');
            root.appendChild(container);
            _this.elements.popup = document.createElement('div');
            var popup = _this.elements.popup;
            popup.classList.add('notificationapi-popup');
            if (options.inline) {
                popup.classList.add('inline');
            }
            else {
                popup.classList.add('popup');
                popup.classList.add('hovering');
                popup.classList.add('closed');
                var button = document.createElement('button');
                button.classList.add('notificationapi-button');
                button.innerHTML = "<span class=\"icon-bell-o\"></span>";
                container.appendChild(button);
                button.onclick = function () {
                    if (popup.classList.contains('closed')) {
                        _this.openInAppPopup();
                    }
                    else {
                        _this.closeInAppPopup();
                    }
                };
                _this.elements.button = button;
                window.addEventListener('click', function (e) {
                    var _a, _b, _c;
                    var clickedPopup = (_a = e.target.closest('.notificationapi-popup')) !== null && _a !== void 0 ? _a : false;
                    var clickedButton = (_b = e.target.closest('.notificationapi-button')) !== null && _b !== void 0 ? _b : false;
                    var clickedPreferences = (_c = e.target.closest('.notificationapi-preferences-container')) !== null && _c !== void 0 ? _c : false;
                    if (!clickedButton && !clickedPopup && !clickedPreferences) {
                        popup.classList.add('closed');
                    }
                });
                var unread = document.createElement('div');
                unread.classList.add('notificationapi-unread');
                button.appendChild(unread);
                _this.elements.unread = unread;
                _this.setInAppUnread(_this.state.unread);
            }
            container.appendChild(popup);
            _this.elements.popupInner = document.createElement('div');
            var popupInner = _this.elements.popupInner;
            popupInner.classList.add('notificationapi-popup-inner');
            popup.appendChild(popupInner);
            _this.elements.popupInner = popupInner;
            _this.elements.header = document.createElement('div');
            var headerCloseButton = document.createElement('button');
            headerCloseButton.classList.add('notificationapi-close-button');
            headerCloseButton.innerHTML =
                '<i class=".notificationapi-arrow .notificationapi-arrow-left"></i>';
            headerCloseButton.addEventListener('click', function () {
                _this.closeInAppPopup();
            });
            var headerHeading = document.createElement('h1');
            headerHeading.innerHTML = 'Notifications';
            var headerPreferencesButton = document.createElement('button');
            headerPreferencesButton.classList.add('notificationapi-preferences-button');
            headerPreferencesButton.innerHTML = '<span class="icon-cog"></span>';
            headerPreferencesButton.addEventListener('click', function () {
                _this.showUserPreferences();
            });
            _this.elements.header.appendChild(headerCloseButton);
            _this.elements.header.appendChild(headerHeading);
            _this.elements.header.appendChild(headerPreferencesButton);
            _this.elements.header.classList.add('notificationapi-header');
            popupInner.appendChild(_this.elements.header);
            var empty = document.createElement('div');
            empty.classList.add('notificationapi-empty');
            empty.innerHTML = "You don't have any notifications!";
            popupInner.appendChild(empty);
            _this.elements.empty = empty;
            _this.processNotifications(_this.state.notifications);
            popupInner.onscroll = function () {
                if (popupInner.scrollTop + popupInner.clientHeight >=
                    popupInner.scrollHeight - 100 &&
                    new Date().getTime() - _this.state.lastNotificationsRequestAt >= 500 &&
                    _this.websocket &&
                    (_this.state.lastResponseNotificationsCount === undefined ||
                        _this.state.lastResponseNotificationsCount >= notificationReqCount)) {
                    _this.state.lastNotificationsRequestAt = new Date().getTime();
                    var moreNotificationsRequest = {
                        route: 'inapp_web/notifications',
                        payload: {
                            before: _this.state.oldestNotificationsDate,
                            count: notificationReqCount
                        }
                    };
                    _this.websocket.send(JSON.stringify(moreNotificationsRequest));
                }
            };
            _this.sendWSMessage({
                route: 'inapp_web/unread_count'
            });
            _this.sendWSMessage({
                route: 'inapp_web/notifications',
                payload: {
                    count: notificationReqCount
                }
            });
            if (_this.websocket) {
                var ws = _this.websocket;
                ws.addEventListener('message', function (m) {
                    var body = JSON.parse(m.data);
                    if (!body || !body.route) {
                        return;
                    }
                    if (body.route === 'inapp_web/unread_count') {
                        var message = body;
                        _this.setInAppUnread(message.payload.count);
                    }
                    if (body.route === 'inapp_web/notifications') {
                        var message = body;
                        _this.state.lastResponseNotificationsCount =
                            message.payload.notifications.length;
                        _this.processNotifications(message.payload.notifications);
                        if (message.payload.notifications.length < notificationReqCount &&
                            !_this.elements.empty) {
                            var noMore = document.createElement('div');
                            noMore.innerHTML = 'No more notifications to load';
                            noMore.classList.add('notificationapi-nomore');
                            popupInner.append(noMore);
                        }
                    }
                    if (body.route === 'inapp_web/new_notifications') {
                        var message = body;
                        var beforeCount = _this.state.notifications.length;
                        _this.processNotifications(message.payload.notifications);
                        var afterCount = _this.state.notifications.length;
                        _this.setInAppUnread(_this.state.unread + afterCount - beforeCount);
                    }
                });
            }
        };
        this.showUserPreferences = function (options) {
            if (!_this.elements.preferencesContainer) {
                var root = document.getElementsByTagName('body')[0];
                if (options === null || options === void 0 ? void 0 : options.parent) {
                    var parentElement = document.getElementById(options.parent);
                    if (!parentElement) {
                        console.error("There are no HTML elements with id=\"".concat(options.parent, "\" on the page."));
                    }
                    else {
                        root = parentElement;
                    }
                }
                var container_1 = document.createElement('div');
                container_1.classList.add('notificationapi-preferences-container');
                if (options === null || options === void 0 ? void 0 : options.parent)
                    container_1.classList.add('inline');
                _this.elements.preferencesContainer = container_1;
                root.appendChild(container_1);
                var backdrop = document.createElement('div');
                backdrop.classList.add('notificationapi-preferences-backdrop');
                backdrop.addEventListener('click', function () {
                    container_1.classList.add('closed');
                });
                container_1.appendChild(backdrop);
                var popup = document.createElement('div');
                popup.classList.add('notificationapi-preferences-popup');
                container_1.appendChild(popup);
                _this.elements.preferencesPopup = popup;
                var close_1 = document.createElement('button');
                close_1.classList.add('notificationapi-preferences-close');
                close_1.addEventListener('click', function () {
                    container_1.classList.add('closed');
                });
                popup.appendChild(close_1);
                var title = document.createElement('h1');
                title.innerHTML = 'Notification Preferences';
                popup.appendChild(title);
                var loading = document.createElement('div');
                loading.classList.add('notificationapi-loading');
                var icon = document.createElement('span');
                icon.classList.add('icon-spinner', 'spinner');
                loading.appendChild(icon);
                popup.appendChild(loading);
                _this.elements.preferencesLoading = loading;
                if (_this.websocket) {
                    var ws = _this.websocket;
                    ws.addEventListener('message', function (m) {
                        var body = JSON.parse(m.data);
                        if (!body || !body.route) {
                            return;
                        }
                        if (body.route === 'user_preferences/preferences') {
                            var message = body;
                            _this.renderPreferences(message.payload.userPreferences);
                        }
                    });
                }
            }
            else {
                _this.elements.preferencesContainer.classList.remove('closed');
            }
            _this.sendWSMessage({
                route: 'user_preferences/get_preferences'
            });
        };
        this.elements = {};
        this.state = {
            initOptions: options,
            lastNotificationsRequestAt: 0,
            notifications: [],
            unread: 0,
            oldestNotificationsDate: ''
        };
        if (options.websocket !== false) {
            var websocketAddress = "".concat((_a = options.websocket) !== null && _a !== void 0 ? _a : defaultWebSocket, "?envId=").concat(encodeURIComponent(options.clientId), "&userId=").concat(encodeURIComponent(options.userId)).concat(options.userIdHash
                ? '&userIdHash=' + encodeURIComponent(options.userIdHash)
                : '');
            this.websocket = new WebSocket(websocketAddress);
        }
    }
    NotificationAPIClient.prototype.openInAppPopup = function () {
        var _a;
        if (this.elements.popup &&
            this.elements.popupInner &&
            this.elements.button &&
            this.state.inappOptions &&
            !this.state.inappOptions.inline) {
            position(this.elements.popup, this.elements.popupInner, this.elements.button, (_a = this.state.inappOptions.popupPosition) !== null && _a !== void 0 ? _a : interfaces_1.PopupPosition.RightBottom);
            this.setInAppUnread(0);
            this.elements.popup.classList.remove('closed');
        }
        if (this.websocket && this.websocket.readyState === 1) {
            var clearReq = {
                route: 'inapp_web/unread_clear'
            };
            this.websocket.send(JSON.stringify(clearReq));
        }
    };
    NotificationAPIClient.prototype.closeInAppPopup = function () {
        if (this.elements.popup &&
            this.state.inappOptions &&
            !this.state.inappOptions.inline) {
            this.elements.popup.classList.add('closed');
        }
    };
    NotificationAPIClient.prototype.setInAppUnread = function (count) {
        this.state.unread = count;
        if (this.elements.unread &&
            this.state.inappOptions &&
            !this.state.inappOptions.inline) {
            if (count === 0) {
                this.elements.unread.classList.add('hidden');
            }
            else {
                this.elements.unread.classList.remove('hidden');
            }
            if (count < 100) {
                this.elements.unread.innerHTML = count + '';
            }
            else {
                this.elements.unread.innerHTML = '+99';
            }
        }
    };
    NotificationAPIClient.prototype.processNotifications = function (notifications) {
        var _this = this;
        var header = this.elements.header;
        var popupInner = this.elements.popupInner;
        if (!header || !popupInner)
            return;
        var newNotifications = notifications.filter(function (n) {
            var found = _this.state.notifications.find(function (existingN) {
                return existingN.id === n.id;
            });
            return found ? false : true;
        });
        this.state.notifications =
            this.state.notifications.concat(newNotifications);
        this.state.notifications.sort(function (a, b) {
            return Date.parse(b.date) - Date.parse(a.date);
        });
        this.state.notifications.map(function (n, i) {
            if (popupInner.querySelector("[data-notification-id=\"".concat(n.id, "\"]"))) {
                return;
            }
            if (!_this.state.oldestNotificationsDate ||
                n.date < _this.state.oldestNotificationsDate) {
                _this.state.oldestNotificationsDate = n.date;
            }
            var notification = document.createElement('a');
            notification.setAttribute('data-notification-id', n.id);
            notification.classList.add('notificationapi-notification');
            if (!n.seen) {
                notification.classList.add('unseen');
            }
            if (n.redirectURL) {
                notification.href = n.redirectURL;
            }
            var notificationImageContainer = document.createElement('div');
            notificationImageContainer.classList.add('notificationapi-notification-imageContainer');
            if (n.imageURL) {
                var notificationImage = document.createElement('img');
                notificationImage.classList.add('notificationapi-notification-image');
                notificationImage.src = n.imageURL;
                notificationImageContainer.appendChild(notificationImage);
            }
            else {
                var notificationIcon = document.createElement('span');
                notificationIcon.classList.add('icon-commenting-o');
                notificationIcon.classList.add('notificationapi-notification-defaultIcon');
                notificationImageContainer.appendChild(notificationIcon);
            }
            notification.appendChild(notificationImageContainer);
            var notificationMetaContainer = document.createElement('div');
            notificationMetaContainer.classList.add('notificationapi-notification-metaContainer');
            var notificationTitle = document.createElement('p');
            notificationTitle.classList.add('notificationapi-notification-title');
            notificationTitle.innerHTML = n.title;
            notificationMetaContainer.appendChild(notificationTitle);
            var date = document.createElement('p');
            date.classList.add('notificationapi-notification-date');
            date.innerHTML = timeAgo
                .format(new Date(n.date), 'round-minute')
                .toString();
            if (date.innerHTML === 'in a moment') {
                date.innerHTML = 'just now';
            }
            notificationMetaContainer.appendChild(date);
            notification.appendChild(notificationMetaContainer);
            if (i === 0) {
                header.insertAdjacentElement('afterend', notification);
            }
            else {
                var preNotificationEl = popupInner.querySelector("[data-notification-id=\"".concat(_this.state.notifications[i - 1].id, "\"]"));
                if (preNotificationEl) {
                    preNotificationEl.insertAdjacentElement('afterend', notification);
                }
                else {
                    console.error('error finding previous notification', _this.state.notifications[i - 1]);
                }
            }
        });
        if (newNotifications.length > 0 && this.elements.empty) {
            this.elements.empty.remove();
            delete this.elements.empty;
        }
    };
    NotificationAPIClient.prototype.renderPreferences = function (preferences) {
        var _this = this;
        var _a, _b;
        if (!this.elements.preferencesPopup)
            return;
        (_a = this.elements.preferencesLoading) === null || _a === void 0 ? void 0 : _a.remove();
        this.elements.preferencesLoading = undefined;
        var popup = this.elements.preferencesPopup;
        var validPreferences = preferences.filter(function (p) { return p.settings.length > 0; });
        if (validPreferences.length === 0 && !this.elements.preferencesEmpty) {
            var empty = document.createElement('div');
            empty.classList.add('notificationapi-preferences-empty');
            empty.innerHTML = 'There are no notifications to configure.';
            popup.appendChild(empty);
            this.elements.preferencesEmpty = empty;
            return;
        }
        (_b = this.elements.preferencesGrid) === null || _b === void 0 ? void 0 : _b.remove();
        this.elements.preferencesGrid = undefined;
        var grid = document.createElement('div');
        grid.classList.add('notificationapi-preferences-grid');
        this.elements.preferencesGrid = grid;
        popup.appendChild(grid);
        var channels = {};
        validPreferences.map(function (p) {
            p.settings.map(function (s) {
                if (!channels[s.channel])
                    channels[s.channel] = s.channelName;
            });
        });
        var row = 1;
        Object.values(channels).map(function (v, i) {
            var channel = document.createElement('div');
            channel.innerHTML = v;
            channel.classList.add('notificationapi-preferences-channel', "notificationapi-preferences-col".concat(i + 2), "notificationapi-preferences-row".concat(row));
            grid.appendChild(channel);
        });
        row++;
        validPreferences.map(function (pref) {
            var title = document.createElement('div');
            title.classList.add('notificationapi-preferences-title', 'notificationapi-preferences-col1', "notificationapi-preferences-row".concat(row));
            title.innerHTML = pref.title;
            grid.appendChild(title);
            pref.settings.map(function (s) {
                var toggle = document.createElement('div');
                var col = Object.keys(channels).indexOf(s.channel) + 2;
                toggle.classList.add('notificationapi-preferences-toggle', "notificationapi-preferences-col".concat(col), "notificationapi-preferences-row".concat(row));
                toggle.setAttribute('data-notificationId', pref.notificationId);
                toggle.setAttribute('data-channel', s.channel);
                var label = document.createElement('label');
                label.classList.add('switch');
                toggle.appendChild(label);
                var input = document.createElement('input');
                input.setAttribute('type', 'checkbox');
                input.checked = s.state;
                label.appendChild(input);
                var i = document.createElement('i');
                label.appendChild(i);
                input.addEventListener('change', function () {
                    grid
                        .querySelectorAll(".notificationapi-preferences-subtoggle[data-notificationid=\"".concat(pref.notificationId, "\"][data-channel=\"").concat(s.channel, "\"] input"))
                        .forEach(function (e) {
                        e.disabled = !input.checked;
                    });
                    _this.sendWSMessage({
                        route: 'user_preferences/patch_preferences',
                        payload: [
                            {
                                notificationId: pref.notificationId,
                                channelPreferences: [
                                    {
                                        channel: s.channel,
                                        state: input.checked
                                    }
                                ]
                            }
                        ]
                    });
                });
                grid.appendChild(toggle);
            });
            row++;
            if (pref.subNotificationPreferences &&
                pref.subNotificationPreferences.length > 0) {
                var expand = document.createElement('button');
                expand.innerHTML = 'expand';
                expand.setAttribute('data-notificationId', pref.notificationId);
                var col = Object.keys(channels).length + 2;
                expand.classList.add('notificationapi-preferences-expand', "notificationapi-preferences-col".concat(col), "notificationapi-preferences-row".concat(row - 1));
                expand.addEventListener('click', function (e) {
                    var expand = e.target;
                    var notificationId = expand.getAttribute('data-notificationId');
                    popup
                        .querySelectorAll("[data-notificationId=\"".concat(notificationId, "\"][data-subNotificationId]"))
                        .forEach(function (e) {
                        e.classList.toggle('closed');
                    });
                });
                grid.appendChild(expand);
                pref.subNotificationPreferences.map(function (subPref) {
                    var title = document.createElement('div');
                    title.classList.add('notificationapi-preferences-subtitle', 'notificationapi-preferences-col1', "notificationapi-preferences-row".concat(row), 'closed');
                    title.setAttribute('data-subNotificationId', subPref.subNotificationId);
                    title.setAttribute('data-notificationId', pref.notificationId);
                    title.innerHTML = subPref.title;
                    grid.appendChild(title);
                    subPref.settings.map(function (s) {
                        var toggle = document.createElement('div');
                        var col = Object.keys(channels).indexOf(s.channel) + 2;
                        toggle.classList.add('notificationapi-preferences-subtoggle', "notificationapi-preferences-col".concat(col), "notificationapi-preferences-row".concat(row), 'closed');
                        toggle.setAttribute('data-notificationId', subPref.notificationId);
                        toggle.setAttribute('data-subNotificationId', subPref.subNotificationId);
                        toggle.setAttribute('data-channel', s.channel);
                        var label = document.createElement('label');
                        label.classList.add('switch', 'small');
                        toggle.appendChild(label);
                        var input = document.createElement('input');
                        input.setAttribute('type', 'checkbox');
                        input.checked = s.state;
                        if (pref.settings.find(function (ps) { return ps.channel === s.channel && ps.state === false; }))
                            input.disabled = true;
                        label.appendChild(input);
                        var i = document.createElement('i');
                        label.appendChild(i);
                        input.addEventListener('change', function () {
                            _this.sendWSMessage({
                                route: 'user_preferences/patch_preferences',
                                payload: [
                                    {
                                        notificationId: pref.notificationId,
                                        subNotificationId: subPref.subNotificationId,
                                        channelPreferences: [
                                            {
                                                channel: s.channel,
                                                state: input.checked
                                            }
                                        ]
                                    }
                                ]
                            });
                        });
                        grid.appendChild(toggle);
                    });
                    row++;
                });
            }
        });
    };
    NotificationAPIClient.prototype.sendWSMessage = function (request) {
        if (!this.websocket)
            return;
        var ws = this.websocket;
        if (ws.readyState == ws.OPEN) {
            ws.send(JSON.stringify(request));
        }
        else {
            ws.addEventListener('open', function () {
                ws.send(JSON.stringify(request));
            });
        }
    };
    return NotificationAPIClient;
}());
exports["default"] = NotificationAPIClient;
